import React from 'react';
import {
  Box,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';

const formatReminderDate = (dateStr) => {
  if (!dateStr) return '—';
  try {
    return format(new Date(dateStr), 'dd MMM yyyy, HH:mm', { locale: pl });
  } catch {
    return dateStr;
  }
};

const ReminderHeaderField = ({
  hasActiveReminder,
  remindAt,
  editable,
  onAddReminder,
  onManageReminder,
}) => {
  const handleEdit = (event) => {
    event.stopPropagation();
    if (hasActiveReminder) {
      onManageReminder();
    } else {
      onAddReminder();
    }
  };

  const handleChipClick = (event) => {
    event.stopPropagation();
    if (hasActiveReminder) {
      onManageReminder();
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
      <Chip
        size="small"
        variant="outlined"
        color={hasActiveReminder ? 'error' : 'default'}
        onClick={hasActiveReminder ? handleChipClick : undefined}
        clickable={hasActiveReminder}
        label={
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
            <Typography component="span" variant="caption" color="text.secondary">
              Przypomnienie:
            </Typography>
            <Typography
              component="span"
              variant="caption"
              sx={{ fontWeight: 600, color: hasActiveReminder ? 'error.dark' : 'text.primary' }}
            >
              {formatReminderDate(remindAt)}
            </Typography>
          </Box>
        }
        sx={{
          height: 'auto',
          py: 0.25,
          '& .MuiChip-label': { px: 1 },
          ...(hasActiveReminder && { cursor: 'pointer' }),
        }}
      />
      {editable && (
        <Tooltip
          title={
            hasActiveReminder
              ? 'Zarządzaj przypomnieniem lub dodaj nowe'
              : 'Dodaj przypomnienie z powiadomieniem e-mail'
          }
        >
          <IconButton
            size="small"
            onClick={handleEdit}
            aria-label="Edytuj przypomnienie"
          >
            <Edit sx={{ fontSize: 15 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ReminderHeaderField;
